import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Grid,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const bannerImage = require("../assets/welcomeImage.jpeg"); // Adjust the path as needed

const FAQPage = () => {
  const [activeCategory, setActiveCategory] = useState("general");
  const faqData = {
    general: [
      {
        question: "Combien de personnes peut accueillir le bus ?",
        answer: "Le bus peut accueillir jusqu'à 18 personnes maximum.",
      },
      {
        question:
          "Peut-on louer le bus pour une soirée privée, un anniversaire, un EVJF/EVG, un concert, un mariage, etc. ?",
        answer:
          "Oui, c'est exactement sa vocation : un lieu mobile, festif et unique pour tous vos événements.",
      },
      {
        question:
          "Le bus est-il adapté à des événements d'entreprise (team building, afterwork, etc.) ?",
        answer:
          "Absolument, il convient parfaitement pour des événements professionnels : afterworks, séminaires mobiles, team building, etc.",
      },
      {
        question: "Y a-t-il une limite d'âge pour les passagers ?",
        answer:
          "Pas de limite d'âge, mais les mineurs doivent obligatoirement être encadrés par un ou plusieurs adultes.",
      },
      {
        question: "Le bus peut-il rester stationné ou doit-il circuler ?",
        answer:
          "Les deux sont possibles, selon vos préférences : stationné comme un lounge, ou en déplacement pour une expérience itinérante.",
      },
    ],
    fonctionnement: [
      {
        question: "Un chauffeur est-il fourni ?",
        answer:
          "Oui, un chauffeur professionnel est inclus dans la prestation.",
      },
      {
        question: "Quel est le périmètre géographique couvert ?",
        answer:
          "Le bus peut circuler partout en France et à l'étranger, selon les conditions définies dans le devis.",
      },
      {
        question: "Quelle est la durée minimale de location ?",
        answer:
          "La location est possible à partir d'une soirée, avec des formules à partir de 3 heures.",
      },
      {
        question: "Est-il possible de visiter le bus avant de réserver ?",
        answer:
          "Oui, bien sûr. Contactez-nous pour fixer un rendez-vous de visite.",
      },
    ],
    equipements: [
      {
        question: "Quels sont les équipements à bord ?",
        answer:
          "Le bus comprend :\n• 3 frigos\n• Chaîne hi-fi + enceintes puissantes\n• Plusieurs télévisions\n• Lecteur DVD, console de jeux\n• Cuisine équipée\n• Nombreux rangements\n• Salon à l'étage\n• Couchages intégrés",
      },
      {
        question: "Y a-t-il des sanitaires à bord ?",
        answer:
          "Oui, des sanitaires pour uriner uniquement sont à disposition.",
      },
      {
        question: "Le bus dispose-t-il de chauffage et climatisation ?",
        answer: "Oui, il est équipé pour toutes les saisons.",
      },
    ],
  };

  const categoryNames = {
    general: "🚌 Général",
    fonctionnement: "🚐 Fonctionnement et conditions",
    equipements: "🎉 Équipements",
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f7f5f2" }}>
      {/* Header Banner */}
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${bannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "35vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          position: "relative",
        }}
      >
        <Box sx={{ width: "100%", padding: "0 20px" }}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: "Sansita One, cursive",
              fontSize: {
                xs: "2.5rem",
                sm: "3rem",
                md: "4rem",
                lg: "4.5rem",
              },
              fontWeight: "bold",
              color: "white",
              textShadow: "2px 2px 8px rgba(31, 1, 1, 0.7)",
              margin: 0,
              marginBottom: 1,
            }}
          >
            FAQ
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.2rem",
                md: "1.5rem",
              },
              color: "white",
              opacity: 0.9,
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Foire Aux Questions
          </Typography>
        </Box>
      </Box>

      {/* Content Area */}
      <Container maxWidth="xl" sx={{ padding: { xs: 2, md: 4 } }}>
        <Grid container spacing={4} sx={{ marginTop: 2 }}>
          {/* Sidebar */}
          <Grid item xs={12} md={4}>
            <Paper
              elevation={2}
              sx={{
                padding: 3,
                backgroundColor: "white",
                borderRadius: 2,
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
              }}
            >
              <List sx={{ padding: 0 }}>
                {Object.entries(categoryNames).map(([key, name]) => (
                  <ListItem
                    key={key}
                    button
                    onClick={() => handleCategoryClick(key)}
                    sx={{
                      marginBottom: 2,
                      borderRadius: 1,
                      cursor: "pointer",
                      backgroundColor:
                        activeCategory === key
                          ? "rgba(200, 70, 83, 0.1)"
                          : "transparent",
                      "&:hover": {
                        backgroundColor:
                          activeCategory === key
                            ? "rgba(200, 70, 83, 0.1)"
                            : "#f5f5f5",
                      },
                      padding: 2,
                      border:
                        activeCategory === key
                          ? "1px solid #c84653"
                          : "1px solid transparent",
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            fontSize: { xs: "0.9rem", md: "1rem" },
                            fontWeight:
                              activeCategory === key ? "bold" : "medium",
                            color:
                              activeCategory === key ? "#c84653" : "#444349",
                          }}
                        >
                          {name}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Grid>

          {/* FAQ Content */}
          <Grid item xs={12} md={8}>
            <Box sx={{ padding: 3 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {faqData[activeCategory].map((item, index) => (
                  <Accordion
                    key={index}
                    sx={{
                      border: "1px solid #c84653",
                      borderRadius: 0,
                      "&:before": {
                        display: "none",
                      },
                      boxShadow: "none",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#c84653" }} />}
                      sx={{
                        backgroundColor: "rgba(200, 70, 83, 0.05)",
                        "&:hover": {
                          backgroundColor: "rgba(200, 70, 83, 0.1)",
                        },
                        padding: "12px 16px",
                        minHeight: "auto",
                        "& .MuiAccordionSummary-content": {
                          margin: "8px 0",
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "1.1rem",
                          fontWeight: 600,
                          color: "#444349",
                        }}
                      >
                        {item.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{
                        backgroundColor: "white",
                        padding: "16px",
                        borderTop: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "1rem",
                          lineHeight: 1.6,
                          color: "#333",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {item.answer}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FAQPage;
